WB.DataManagers = WB.DataManagers || {};
WB.DataManagers.PageLayouts = function (_AppData, Metadata, $location, $q, PageLayoutsDataService, DataManagerUtility) {

    if (_AppData.PageLayouts) {
        _AppData.PageLayouts.forEach(function(pageLayout) {
            DataManagerUtility.SetCache({
                name: 'PageLayouts',
                signature: pageLayout.PageLayoutAlias,
                value: $q(function(resolve, reject) {
                    resolve(pageLayout);
                }),
                expiryKey: 'PageLayouts'
            });
        });
    }

    this.GetPageLayoutForAlias = function(alias) {
        var resolver = DataManagerUtility.GetCache({
            name: 'PageLayouts',
            signature: alias
        });

        if (resolver) {
            return resolver;
        } else {
            var newCache = {
                name: 'PageLayouts',
                signature: alias,
                value: PageLayoutsDataService.GetPageLayoutForAlias(alias),
                expiryKey: 'PageLayouts'
            };
            DataManagerUtility.SetCache(newCache);
            newCache.value.catch(function(err) {
                DataManagerUtility.ClearCache({ name: 'PageLayouts', signature: alias });
            });
            return newCache.value;
        }
    };

};
WB.DataManagers.PageLayouts.$inject = ['_AppData', 'Metadata', '$location', '$q', 'PageLayoutsDataService', 'DataManagerUtility'];

WB.Core.service('PageLayoutsDataManager', WB.DataManagers.PageLayouts);
